var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF5959",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M20 2.667H8a2.667 2.667 0 0 0-2.667 2.666v21.334A2.667 2.667 0 0 0 8 29.333h16a2.667 2.667 0 0 0 2.667-2.666V9.333z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF5959",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M18.667 2.667V8a2.667 2.667 0 0 0 2.666 2.667h5.334M13.333 12h-2.666M21.333 17.333H10.667M21.333 22.667H10.667"
})));
export { SvgText as ReactComponent };
export default __webpack_public_path__ + "36b6bdb2785c8086a61b9e3957582311.svg";